
export const PEN_PACKET_START = 0xc0;
export const PEN_PACKET_END = 0xc1;
export const PK_DLE = 0x7d;


